import { useEffect, useState } from "react"

export default function Alert({message = '', show = false}) {

    return (
         <>
         { show &&
           <div className='bg-slate-700 text-white text-center rounded-md absolute bottom-5 left-1/2 -translate-x-1/2 px-2 py-1 transition-all duration-300'>
                <span className="text-sm">{message}</span>
           </div>
           }
        </>
    )
}